<template>
    <div>
        <div class="panel animated fadeInRightBig">
            <div class="panel-heading">
                <div class="panel-title">
                    <span class="title">
                        <b>Mensagem SAC</b>

                        <i class="fa fa-headphones" style="float:right;margin-top:6px;font-size:21px;"></i>
                    </span>

                    <hr class="m-t-md">
                </div>
                <div class="panel-body" style="margin-top:-10px;font-size:16px;">
                    <span class="block">
                        <b><i class="fa fa-user-circle"></i> Enviada por:</b> {{ message.name }}
                    </span>

                    <span class="block m-t-sm">
                        <b><i class="fa fa-envelope"></i> E-mail:</b> {{ message.email }}
                    </span>

                    <span class="block m-t-sm">
                        <b><i class="fa fa-phone"></i> Telefone:</b> {{ message.phone }}
                    </span>

                    <span class="block m-t-sm">
                        <b><i class="fa fa-comment"></i> Mensagem:</b> {{ message.message }}
                    </span>

                    <hr class="m-t-lg">

                    <div class="block text-right" style="margin-bottom:-10px;">
                        <router-link to="/contactUs" class="btn btn-info m-r-sm m-b-sm">
                            <i class="fa fa-arrow-left"></i> Voltar
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                message: {},
                errors: undefined
            }
        },
        computed: {},
        methods: {
            getMessage: function(){
                let self = this;
                let id   = self.$route.params.id;
                let api  = self.$store.state.api + 'contactUs/' + id;

                self.$http.get(api)
                    .then((response) => {
                        self.message = response.data;
                    })
                    .catch((error) => {
                        self.$message(null, error.response, 'error');
                    });
            }
        },
        mounted: function(){
            this.getMessage();
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/ContactUs/View.vue